import { e as _taggedTemplateLiteral, c as _slicedToArray, f as _asyncToGenerator, a as _toConsumableArray, _ as _objectSpread2 } from './_rollupPluginBabelHelpers-fb970440.js';
import React, { useState, useContext, useEffect } from 'react';
import { useQuantaFormikContext, useResponsiveParams, Text, Button, QuantaForm, InputGrid, NotificationList, MixedGridGroup, SearchResultsModal } from 'quanta-ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faSpinner, faExclamationTriangle, faSearch, faRupeeSign, faTrashAlt, faPlus, faExclamationCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { u as useFetchQuery } from './useFetchQuery-56ba5b94.js';
import { gql, useQuery } from '@apollo/client';
import { a as ConfigContext } from './ConfigProvider-9522944e.js';
import 'react-helmet';
import { useParams } from 'react-router-dom';
import './queries-3df8abcc.js';
import { L as Loading } from './loading-c16d3bd3.js';
import './queries-a3e6305b.js';
import { I as IconIdle } from './icon-search-idle-a2977e92.js';

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15$1;
var INTERMEDIARY_CD_ACCOUNTS$1 = gql(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  query intermediaryCDAccounts($input: intermediaryCDAccsInput) {\n    intermediaryCDAccounts(input: $input) {\n      AccountID\n      AccountBalance\n    }\n  }\n"])));
var GET_CUSTOMER_TYPE_DOMAIN$1 = gql(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n  query getCustomerTypeDomain {\n    customerTypeList {\n      code\n      value\n    }\n  }\n"])));
var CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL$1 = gql(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n  query customerIndividualDetail {\n    salutationList {\n      code\n      value\n      gender\n    }\n    genderList {\n      code\n      value\n    }\n    maritalStatusList {\n      code\n      value\n    }\n    occupationList {\n      code\n      value\n    }\n    nomineeRelationshipList {\n      code\n      value\n    }\n    idProofTypeList {\n      code\n      value\n    }\n    nationalityList {\n      code\n      value\n    }\n  }\n"])));
var CUSTOMER_BANK_DETAILS$1 = gql(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n  query customerBankDetails($filter: BankFilter) {\n    _bankInfo_meta(filter: $filter) {\n      maxRow\n      resultCount\n      infoMessages\n      metaMessage {\n        type\n        header\n        message\n      }\n    }\n    bankInfo(filter: $filter) {\n      branch_name\n      ifsc_code\n      name\n      branch_address\n      bank_code\n    }\n  }\n"])));
var GET_DATE_TIME$1 = gql(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n  query getDateTime {\n    datetimeValue {\n      time\n      date\n    }\n  }\n"])));
var PAY_PREMIUM_LIST$1 = gql(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["\n  query payPremiumList($imdCode: String) {\n    PayMethodPayerTypeList {\n      code\n      value\n    }\n    ChequeTypeList {\n      code\n      value\n    }\n    PaymentTypeList(imdCode: $imdCode) {\n      code\n      value\n    }\n    ProposalPaymentTypeList {\n      code\n      value\n    }\n  }\n"])));
var VERIFY_ONLINE_TRANSACTION$1 = gql(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["\n  query verifyOnlineTransaction($input: verifyOnlineTranscInput) {\n    verifyOnlineTransaction(input: $input) {\n      isPaymentDone\n      transactionAmt\n      transactionDate\n    }\n  }\n"])));
var ISSUE_POLICY = gql(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n  mutation renewPolicy($input: PolicyInput) {\n    issuePolicy(input: $input) {\n      policyNo\n      receiptID\n      referenceNumber\n      digiLink\n      displayMessage\n      additionalMessage\n    }\n  }\n"])));
var CAR_VEHICLE_INSPECTION = gql(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n  query carSecureVehicleInspection($input: VehicleInspectionInput) {\n    carSecureVehicleInspection(input: $input) {\n      PreInspectionstatus\n    }\n  }\n"])));
var AGENCY_NAME = gql(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n  query agencyname($input: DomainInput) {\n    getDomainData(input: $input) {\n      code\n      value\n    }\n  }\n"])));
var KASH_PASH_SLIP = gql(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteral(["\n  mutation InsertKashPaySlip($input:kashPaySlipInput){\n    kashPaySlip(input: $input){\n      status\n    }\n  }\n"])));
var HOUSE_BANK_BRANCH_FETCH = gql(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteral(["\n  query houseBkBranchFetch($input: houseBankBranchFetchInput) {\n    houseBkBranchFetch(input: $input) {\n      FinancierBranchCD\n      FinancierName\n    }\n  }\n"])));
var HOUSE_BANK_ACCOUNT_FETCH = gql(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteral(["\n  query houseBankAccountFetch($input: houseBankAccountFetchInput) {\n    houseBankAccountFetch(input: $input) {\n      BankAccount\n      BankDefaultFlag\n    }\n  }\n"])));
var LOOKUP_INTERMEDIARY = gql(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteral(["\n  query intermediaryLookup($filter: UserSearchFilter) {\n    intermediaryLookup(filter: $filter) {\n      intermediaryName\n      intermediaryStartDate\n      intermediaryEndDate\n      officeCdList {\n        officeCd\n        officeName\n      }\n    }\n  }\n"])));
var GET_INTERMEDIARY_LIST = gql(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteral(["\n  query myIntermediaries {\n    myIntermediaries {\n      intermediaryName\n      intermediaryCode\n      isSelected\n      businessLocations {\n        code\n        name\n      }\n    }\n  }\n"])));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39, _templateObject40, _templateObject41;
var GET_BUY_HEALTH_POLICY_VAR_DETAILS = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query getBuyHealthPolicyDetails {\n    buyHealthPolicy @client\n  }\n"])));
var GET_MEDICAL_QUESTIONS = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query getMedicalQuestions($input: productCodeInput) {\n    productQuestionList(input: $input) {\n      srNo\n      label\n      isChkReq\n      isChkTxtReq\n      isParent\n      condToChild\n      childQuesNo\n    }\n  }\n"])));
var LOB_PRODUCT_LIST = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query lobProductList {\n    lobProductList {\n      lob_name\n      lob_code\n      products {\n        product_name\n        product_code\n        linkTo\n      }\n    }\n  }\n"])));
var SAVE_QUOTE = gql(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  mutation saveQuote($input: QuoteInput) {\n    saveQuote(input: $input) {\n      quoteNumber\n      quoteCreationDate\n      status\n    }\n  }\n"])));
var SEND_POLICY_SMS = gql(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  mutation sendPolicySms(\n    $input: ProposalInput\n    $proposalNumber: String\n    $mobile: String\n    $policyNumber: String\n    $alternateMobileNos: [String]\n  ) {\n    sendPolicySMS(\n      input: $input\n      proposalNumber: $proposalNumber\n      mobile: $mobile\n      policyNumber: $policyNumber\n      alternateMobileNos: $alternateMobileNos\n    ) {\n      message\n    }\n  }\n"])));
var SEND_POLICY_EMAIL = gql(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  mutation sendPolicyEmail(\n    $input: ProposalInput\n    $proposalNumber: String\n    $email: String\n    $policyNumber: String\n    $ccEmailIds: [String]\n  ) {\n    sendPolicyEmail(\n      input: $input\n      proposalNumber: $proposalNumber\n      email: $email\n      policyNumber: $policyNumber\n      ccEmailIds: $ccEmailIds\n    ) {\n      message\n    }\n  }\n"])));
var SEND_POLICY_PDF = gql(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  mutation sendPolicyPDF(\n    $input: ProposalInput\n    $proposalNumber: String\n    $policyNumber: String\n  ) {\n    sendPolicyPDF(\n      input: $input\n      proposalNumber: $proposalNumber\n      policyNumber: $policyNumber\n    ) {\n      base64Pdf\n    }\n  }\n"])));
var SEARCH_CUSTOMER_BY_NUMBER = gql(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  query searchCustomerByNumber($input: ViewCustInput) {\n    customer(input: $input) {\n      cust_number\n      cust_type {\n        code\n        value\n      }\n      is_blackListed\n      cust_ref_number\n      ciu_type\n      bank_detail {\n        name\n        branch_name\n        ifsc_code\n        acc_number\n      }\n      indv_detail {\n        employeeNumber\n        gst_number\n        title {\n          code\n          value\n        }\n        first_name\n        middle_name\n        surname\n        full_name\n        gender {\n          code\n          value\n        }\n        date_of_birth\n        id_proof_type {\n          code\n          value\n        }\n        id_proof_number\n        pan_card_number\n        marital_status {\n          code\n          value\n        }\n        occupation {\n          code\n          value\n        }\n        nationality {\n          code\n          value\n        }\n      }\n      org_detail {\n        org_name\n        org_type {\n          code\n          value\n        }\n        contact_name\n        contact_email\n        tan_number\n        reg_number\n        gst_number\n      }\n      contact {\n        email\n        mobile\n        telephone\n        fax_number\n        alt_telephone\n        alt_mobile\n      }\n      permanent_address {\n        address_line1\n        address_line2\n        address_line3\n        land_mark\n        city\n        district\n        state\n        pin_code\n      }\n      comm_equal_perm\n      communication_address {\n        address_line1\n        address_line2\n        address_line3\n        land_mark\n        city\n        district\n        state\n        pin_code\n      }\n      alert_action {\n        alertCount\n        alertContext {\n          alert\n          action\n        }\n      }\n    }\n  }\n"])));
var SEARCH_CUSTOMERS = gql(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  query searchCustomers($filter: CustomerFilter) {\n    _customer_meta(filter: $filter) {\n      resultCount\n      maxRow\n      infoMessages\n      metaMessage {\n        type\n        header\n        message\n      }\n    }\n    customers(filter: $filter) {\n      cust_type {\n        code\n        value\n      }\n      cust_number\n      indv_detail {\n        full_name\n      }\n      org_detail {\n        org_name\n      }\n      contact {\n        email\n        mobile\n      }\n      permanent_address {\n        location\n      }\n    }\n  }\n"])));
var GET_CUSTOMER_TYPE_DOMAIN = gql(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  query getCustomerTypeDomain {\n    customerTypeList {\n      code\n      value\n    }\n  }\n"])));
var PINCODE_LOOKUP = gql(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  query customerAddress($filter: PincodeFilter) {\n    pincodeInfo(filter: $filter) {\n      cityCode\n      city\n      districtCode\n      district\n      pinCode\n      pinCodeLocality\n      stateCode\n      state\n      countryCode\n      country\n    }\n  }\n"])));
var CALCULATE_PREMIUM_FOR_PROPOSAL = gql(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  query calculatePremiumForProposal($input: ProposalInput) {\n    calculatePremiumForProposal(input: $input) {\n      basePremium\n      loadingDiscount\n      netPremium\n      gst\n      stampDuty\n      totalPremium\n      loading {\n        name\n        amount\n      }\n      discount {\n        name\n        amount\n      }\n      breakup {\n        relationship\n        gender\n        age\n        premium\n        ppcTestLevel\n      }\n      warningMsg\n    }\n  }\n"])));
var SAVE_PROPOSAL = gql(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  mutation saveProposal($input: ProposalInput) {\n    saveProposal(input: $input) {\n      customerID\n      proposalNumber\n      proposalEndDate\n      proposalStatus\n      isApplicableForPayment\n      premium {\n        basePremium\n        loadingDiscount\n        netPremium\n        gst\n        stampDuty\n        totalPremium\n        loading {\n          name\n          amount\n        }\n        discount {\n          name\n          amount\n        }\n        breakup {\n          relationship\n          gender\n          age\n          premium\n        }\n      }\n      warningMsg\n    }\n  }\n"])));
var SEND_PROPOSAL_PDF = gql(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  mutation sendProposalPDF(\n    $input: ProposalInput\n    $proposalNumber: String\n  ) {\n    sendProposalPDF(input: $input, proposalNumber: $proposalNumber) {\n      base64Pdf\n    }\n  }\n"])));
var BUY_POLICY = gql(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  mutation buyPolicy($input: PolicyInput) {\n    issuePolicy(input: $input) {\n      policyNo\n      receiptID\n      referenceNumber\n      digiLink\n      displayMessage\n      additionalMessage\n    }\n  }\n"])));
var QUERY_STATE = gql(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  query {\n    quoteIntermediary @client\n  }\n"])));
var CUSTOMER_BANK_DETAILS = gql(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  query customerBankDetails($filter: BankFilter) {\n    _bankInfo_meta(filter: $filter) {\n      maxRow\n      resultCount\n      infoMessages\n      metaMessage {\n        type\n        header\n        message\n      }\n    }\n    bankInfo(filter: $filter) {\n      branch_name\n      ifsc_code\n      name\n      branch_address\n      bank_code\n      micr_code\n    }\n  }\n"])));
var RENEWAL_MANDATE_DETAILS = gql(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  query renewalMandateData($productCode: StrictNumber) {\n    PRD_TermForMandate(productCode: $productCode) {\n      code\n      value\n    }\n    PRD_RenewalPaymentMandateTakenInTheNameOf(\n      productCode: $productCode\n    ) {\n      code\n      value\n    }\n    typeOfDebit {\n      code\n      value\n    }\n    destinationBankAccountType {\n      code\n      value\n    }\n  }\n"])));
var DEFAULT_BANK_NAME = gql(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  query defaultBankName {\n    defaultBankName {\n      code\n      value\n    }\n  }\n"])));
var FINAL_COLLECTION_DATE = gql(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  query finalCollectionDate($input: FinalCollectDateInput) {\n    finalCollectionDate(input: $input) {\n      date\n    }\n  }\n"])));
var PROPOSER_DROPDOWN_DETAIL = gql(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  query getProposerDropdownList($productCode: StrictNumber) {\n    PRD_OccupationList(productCode: $productCode) {\n      code\n      value\n    }\n    PRD_PreExistDiseaseWaitPeriod(productCode: $productCode) {\n      code\n      value\n    }\n    PRD_NomiRelationWithMemb(productCode: $productCode) {\n      code\n      value\n    }\n    PRD_ApointRelationWithMinNomi(productCode: $productCode) {\n      code\n      value\n    }\n    PRD_CumulativeBonus(productCode: $productCode) {\n      code\n      value\n    }\n  }\n"])));
var CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL = gql(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  query customerIndividualDetail {\n    salutationList {\n      code\n      value\n      gender\n    }\n    genderList {\n      code\n      value\n    }\n    maritalStatusList {\n      code\n      value\n    }\n    occupationList {\n      code\n      value\n    }\n    nomineeRelationshipList {\n      code\n      value\n    }\n    idProofTypeList {\n      code\n      value\n    }\n    nationalityList {\n      code\n      value\n    }\n    eiaRequired {\n      code\n      value\n    }\n  }\n"])));
var GET_BUSINESS_TYPE = gql(_templateObject23 || (_templateObject23 = _taggedTemplateLiteral(["\n  query businessType {\n    businessTypeList {\n      code\n      value\n    }\n  }\n"])));
var GET_DATE_TIME = gql(_templateObject24 || (_templateObject24 = _taggedTemplateLiteral(["\n  query getDateTime {\n    datetimeValue {\n      time\n      date\n    }\n  }\n"])));
var GET_GENDER_LIST = gql(_templateObject25 || (_templateObject25 = _taggedTemplateLiteral(["\n  query genderList {\n    genderList {\n      code\n      value\n    }\n  }\n"])));
var CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL = gql(_templateObject26 || (_templateObject26 = _taggedTemplateLiteral(["\n  query customerOrganisationDetails {\n    organisationList {\n      code\n      value\n    }\n  }\n"])));
var PAY_PREMIUM_LIST = gql(_templateObject27 || (_templateObject27 = _taggedTemplateLiteral(["\n  query payPremiumList {\n    PayMethodPayerTypeList {\n      code\n      value\n    }\n    ChequeTypeList {\n      code\n      value\n    }\n    PaymentTypeList {\n      code\n      value\n    }\n    ProposalPaymentTypeList {\n      code\n      value\n    }\n  }\n"])));
var VERIFY_ONLINE_TRANSACTION = gql(_templateObject28 || (_templateObject28 = _taggedTemplateLiteral(["\n  query verifyOnlineTransaction($input: verifyOnlineTranscInput) {\n    verifyOnlineTransaction(input: $input) {\n      isPaymentDone\n    }\n  }\n"])));
var INTERMEDIARY_CD_ACCOUNTS = gql(_templateObject29 || (_templateObject29 = _taggedTemplateLiteral(["\n  query intermediaryCDAccounts($input: intermediaryCDAccsInput) {\n    intermediaryCDAccounts(input: $input) {\n      AccountID\n      AccountBalance\n    }\n  }\n"])));
var ROLLOVER_COMPANY_LIST = gql(_templateObject30 || (_templateObject30 = _taggedTemplateLiteral(["\n  query rollOverCompanyList {\n    rolloverCompanyList {\n      code\n      value\n    }\n  }\n"])));
var DEFAULT_ID_PROOF = gql(_templateObject31 || (_templateObject31 = _taggedTemplateLiteral(["\n  query defaultIDProof {\n    defaultIdProof {\n      code\n      value\n    }\n  }\n"])));
var CHARACTER_LIMIT_LIST = gql(_templateObject32 || (_templateObject32 = _taggedTemplateLiteral(["\n  query characterLimitList {\n    characterLimitList {\n      code\n      value\n    }\n  }\n"])));
var RELATIONSHIP_WITH_PROPOSER = gql(_templateObject33 || (_templateObject33 = _taggedTemplateLiteral(["\n  query relationshipwithproposer {\n    relationshipwithproposer {\n      code\n      value\n    }\n  }\n"])));
var DOCUMENT_STATIC_DATA = gql(_templateObject34 || (_templateObject34 = _taggedTemplateLiteral(["\n  query documentExtensions {\n    #documentListCarSecure {\n    #  code\n    #  value\n    #}\n    documentExtensions {\n      code\n      value\n    }\n    docFileSizeLimit {\n      code\n      value\n    }\n    #docAddLimit {\n    #code\n    #value\n    #}\n    docDescCharacterLimit {\n      code\n      value\n    }\n  }\n"])));
var GET_DOCUMENTS_INFO = gql(_templateObject35 || (_templateObject35 = _taggedTemplateLiteral(["\n  query documentsInfo($input: IDInput) {\n    getDocumentsForCustomer(input: $input) {\n      documentID\n      documentName\n      documentFileName\n      documentExtension\n      documentSize\n      documentDescription\n    }\n    documentList(input: $input) {\n      code\n      value\n    }\n  }\n"])));
var GET_DOCUMENTS_LIST = gql(_templateObject36 || (_templateObject36 = _taggedTemplateLiteral(["\n  query documentList($input: IDInput) {\n    documentList(input: $input) {\n      code\n      value\n    }\n  }\n"])));
var VIEW_DOCUMENT = gql(_templateObject37 || (_templateObject37 = _taggedTemplateLiteral(["\n  query viewDocument($input: ViewDocumentInput) {\n    viewDocument(input: $input) {\n      base64String\n      documentExtension\n      documentFileName\n    }\n  }\n"])));
var UPLOAD_DOCUMENT = gql(_templateObject38 || (_templateObject38 = _taggedTemplateLiteral(["\n  mutation uploadDocument($input: UploadDocumentInput) {\n    uploadDocuments(input: $input) {\n      uploadStatus\n      uploadStatusType\n      documentDetails {\n        documentID\n        documentName\n        documentFileName\n        documentExtension\n        documentSize\n        documentDescription\n      }\n      failedDocDtls {\n        documentFileName\n        ErrorMsg\n      }\n    }\n  }\n"])));
var INSERT_DOCUMENT_LIST = gql(_templateObject39 || (_templateObject39 = _taggedTemplateLiteral(["\n  query inserKitesDocList($input: InsertDocListInput) {\n    inserKitesDocList(input: $input) {\n      insertStatus\n    }\n  }\n"])));
var CHECK_IMD_CONFIG = gql(_templateObject40 || (_templateObject40 = _taggedTemplateLiteral(["\n  query checkConfigImd($intermediaryCode: String){\n    checkConfigImd( intermediaryCode: $intermediaryCode){\n      isConfiguredIMD\n    }\n  }\n"])));
var PROFILE_DETAILS = gql(_templateObject41 || (_templateObject41 = _taggedTemplateLiteral(["\n  query userMyDetail {\n    userMyDetail {\n      userId\n      userType {\n        typeName\n      }\n      profile {\n        userImage\n        firstName\n        middleName\n        lastName\n        mobileNumber\n        emailId\n      }\n      userCategory {\n        categoryName\n      }\n      organisation {\n        intermediaries {\n          intermediaryName\n          intermediaryCode\n          isSelected\n        }\n      }\n      status\n    }\n  }\n"])));

function OnlinePayment(_ref) {
  var _values$onlinePayment, _values$onlinePayment2, _values$onlinePayment3, _values$onlinePayment4, _ref2, _dataBuyPolicy$buyHea, _values$onlinePayment11, _values$onlinePayment12, _values$onlinePayment13, _values$onlinePayment14, _values$onlinePayment15, _values$onlinePayment16;

  var totalPremium = _ref.totalPremium,
      transactionId = _ref.transactionId,
      isTransactionIdVerified = _ref.isTransactionIdVerified;

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values,
      setFieldValue = _useQuantaFormikConte.setFieldValue;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      loadingVerifyTransaction = _useState2[0],
      setLoadingTransaction = _useState2[1];

  var _useState3 = useState((values === null || values === void 0 ? void 0 : (_values$onlinePayment = values.onlinePayment) === null || _values$onlinePayment === void 0 ? void 0 : (_values$onlinePayment2 = _values$onlinePayment.transactionId) === null || _values$onlinePayment2 === void 0 ? void 0 : _values$onlinePayment2.toLowerCase()) === (transactionId === null || transactionId === void 0 ? void 0 : transactionId.toLowerCase()) ? isTransactionIdVerified : !(values !== null && values !== void 0 && (_values$onlinePayment3 = values.onlinePayment) !== null && _values$onlinePayment3 !== void 0 && _values$onlinePayment3.isTransactionIdVerified) ? null : values === null || values === void 0 ? void 0 : (_values$onlinePayment4 = values.onlinePayment) === null || _values$onlinePayment4 === void 0 ? void 0 : _values$onlinePayment4.isTransactionIdVerified),
      _useState4 = _slicedToArray(_useState3, 2),
      transactionVerified = _useState4[0],
      setTransactionVerified = _useState4[1];

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first'
  });
      _useQuery.loading;
      _useQuery.error;
      var dataBuyPolicy = _useQuery.data;

  if (dataBuyPolicy) {
    //console.log("Online Payment dataBuyPolicy", dataBuyPolicy);
    var prembuyHealthPolicy = dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy;
    prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.quoteData;
    var premplanData = prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.planData;
    premplanData === null || premplanData === void 0 ? void 0 : premplanData.plans;
  }

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      alerts = _useState6[0],
      setAlerts = _useState6[1];

  var fetchQuery = useFetchQuery();
  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });
  var grid_data = (_ref2 = [{
    type: 'text',
    maxLength: 15,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "Transaction ID ", /*#__PURE__*/React.createElement(Text, {
      severity: "error"
    }, "*")),
    size: 'large',
    name: 'onlinePayment.transactionId',
    onDataChange: function onDataChange(val, _) {
      setTransactionVerified(null);
      setFieldValue("onlinePayment.isTransactionIdVerified", false);
    },
    disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea === void 0 ? void 0 : _dataBuyPolicy$buyHea.isProposalApplicableForPayment) === false
  }, {
    type: 'render',
    component: function component() {
      return transactionVerified ? /*#__PURE__*/React.createElement(Text, {
        className: "mt-8 w-28 h-11 flex justify-end items-center -ml-2",
        severity: "success",
        type: "large"
      }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faCheck,
        className: "mr-2"
      }), /*#__PURE__*/React.createElement(Text, {
        type: "title"
      }, "Verified")) : /*#__PURE__*/React.createElement(Button, {
        disabled: loadingVerifyTransaction || values.onlinePayment.transactionId && (!(values.onlinePayment.transactionId.toString().length >= 11 && values.onlinePayment.transactionId.toString().length <= 15) || !values.onlinePayment.transactionId.toString().match(/^[0-9]+$/)),
        type: 'button',
        size: "small",
        className: "mt-8 w-40 h-11 flex justify-end",
        onClick: /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_) {
            var _values$onlinePayment5, _values$onlinePayment6, _values$onlinePayment7, _values$onlinePayment8, _values$onlinePayment9;

            var _values$onlinePayment10, verifyTransactionId, _yield$verifyTransact, verificationData, _verificationData$ver, _verificationData$ver2, _verificationData$ver3;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    if (!(values !== null && values !== void 0 && (_values$onlinePayment5 = values.onlinePayment) !== null && _values$onlinePayment5 !== void 0 && _values$onlinePayment5.transactionId && (values === null || values === void 0 ? void 0 : (_values$onlinePayment6 = values.onlinePayment) === null || _values$onlinePayment6 === void 0 ? void 0 : (_values$onlinePayment7 = _values$onlinePayment6.transactionId) === null || _values$onlinePayment7 === void 0 ? void 0 : _values$onlinePayment7.length) > 0 && values !== null && values !== void 0 && (_values$onlinePayment8 = values.onlinePayment) !== null && _values$onlinePayment8 !== void 0 && (_values$onlinePayment9 = _values$onlinePayment8.transactionId) !== null && _values$onlinePayment9 !== void 0 && _values$onlinePayment9.match(/^[a-zA-Z0-9]+$/))) {
                      _context.next = 19;
                      break;
                    }

                    _context.prev = 1;
                    verifyTransactionId = fetchQuery({
                      query: VERIFY_ONLINE_TRANSACTION$1,
                      variables: {
                        input: {
                          transactionNumber: values === null || values === void 0 ? void 0 : (_values$onlinePayment10 = values.onlinePayment) === null || _values$onlinePayment10 === void 0 ? void 0 : _values$onlinePayment10.transactionId,
                          premiumAmt: totalPremium
                        }
                      }
                    });
                    setAlerts([]);
                    setLoadingTransaction(true);
                    _context.next = 7;
                    return verifyTransactionId;

                  case 7:
                    _yield$verifyTransact = _context.sent;
                    verificationData = _yield$verifyTransact.data;
                    setLoadingTransaction(false);

                    if (verificationData.verifyOnlineTransaction.isPaymentDone) {
                      setTransactionVerified(true);
                      setFieldValue("onlinePayment.isTransactionIdVerified", true);
                      setFieldValue("onlinePayment.transactionDate", (_verificationData$ver = verificationData.verifyOnlineTransaction) === null || _verificationData$ver === void 0 ? void 0 : _verificationData$ver.transactionDate);
                      setFieldValue("onlinePayment.transactionAmt", (_verificationData$ver2 = verificationData.verifyOnlineTransaction) === null || _verificationData$ver2 === void 0 ? void 0 : _verificationData$ver2.transactionAmt);
                      setFieldValue("receiptAmount", (_verificationData$ver3 = verificationData.verifyOnlineTransaction) === null || _verificationData$ver3 === void 0 ? void 0 : _verificationData$ver3.transactionAmt);
                    } else {
                      setLoadingTransaction(false);
                      setTransactionVerified(false);
                      setAlerts([{
                        header: 'Transaction ID verification failure',
                        id: Date.now(),
                        content: /*#__PURE__*/React.createElement("div", {
                          className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                        }, /*#__PURE__*/React.createElement("span", null, "Transaction ID cannot be verified. Please try with some other transaction ID.")),
                        type: 'error',
                        timeout: null,
                        disableClose: false
                      }]);
                      window.scrollTo({
                        top: 0,
                        behavior: 'smooth'
                      });
                    }

                    _context.next = 19;
                    break;

                  case 13:
                    _context.prev = 13;
                    _context.t0 = _context["catch"](1);
                    setLoadingTransaction(false);
                    setTransactionVerified(false);
                    setAlerts([{
                      header: 'Transaction ID verification failure',
                      id: Date.now(),
                      content: /*#__PURE__*/React.createElement("div", {
                        className: "flex flex-row flex-wrap space-y-2 w-full h-full"
                      }, /*#__PURE__*/React.createElement("span", null, "".concat(_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message, ". Please try with some other transaction ID"))),
                      type: 'error',
                      timeout: null,
                      disableClose: false
                    }]);
                    window.scrollTo({
                      top: 0,
                      behavior: 'smooth'
                    });

                  case 19:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee, null, [[1, 13]]);
          }));

          return function (_x) {
            return _ref3.apply(this, arguments);
          };
        }(),
        flat: true,
        iconPre: /*#__PURE__*/React.createElement("div", {
          className: "text-base"
        }, loadingVerifyTransaction ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faSpinner,
          spin: true,
          className: 'mx-2'
        }) : transactionVerified === false ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faExclamationTriangle,
          className: 'mx-2'
        }) : transactionVerified ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faCheck,
          className: 'mx-2'
        }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faSearch,
          className: 'mx-2'
        }))
      }, loadingVerifyTransaction ? /*#__PURE__*/React.createElement("span", {
        className: "text-base"
      }, "Verifying") : transactionVerified === false ? /*#__PURE__*/React.createElement("span", {
        className: "text-base"
      }, "Not Verified") : transactionVerified ? /*#__PURE__*/React.createElement("span", {
        className: "text-base"
      }, "Verified") : /*#__PURE__*/React.createElement("span", {
        className: "text-base"
      }, "Verify"));
    }
  }, {}, (values === null || values === void 0 ? void 0 : (_values$onlinePayment11 = values.onlinePayment) === null || _values$onlinePayment11 === void 0 ? void 0 : (_values$onlinePayment12 = _values$onlinePayment11.isTransactionIdVerified) === null || _values$onlinePayment12 === void 0 ? void 0 : (_values$onlinePayment13 = _values$onlinePayment12.toString()) === null || _values$onlinePayment13 === void 0 ? void 0 : _values$onlinePayment13.toLowerCase()) === 'true' ? {
    type: 'text',
    maxLength: 15,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "Transaction Amount ", /*#__PURE__*/React.createElement(Text, {
      severity: "error"
    })),
    size: 'large',
    name: 'onlinePayment.transactionAmt',
    disabled: true
  } : null, (values === null || values === void 0 ? void 0 : (_values$onlinePayment14 = values.onlinePayment) === null || _values$onlinePayment14 === void 0 ? void 0 : (_values$onlinePayment15 = _values$onlinePayment14.isTransactionIdVerified) === null || _values$onlinePayment15 === void 0 ? void 0 : (_values$onlinePayment16 = _values$onlinePayment15.toString()) === null || _values$onlinePayment16 === void 0 ? void 0 : _values$onlinePayment16.toLowerCase()) === 'true' ? {
    type: 'text',
    maxLength: 15,
    label: /*#__PURE__*/React.createElement(React.Fragment, null, "Transaction Date ", /*#__PURE__*/React.createElement(Text, {
      severity: "error"
    })),
    size: 'large',
    name: 'onlinePayment.transactionDate',
    disabled: true
  } : null]) === null || _ref2 === void 0 ? void 0 : _ref2.filter(function (d) {
    return d;
  });
  return /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(InputGrid, {
    data: grid_data,
    repeat: repeat,
    titleType: "title",
    titleSeverity: "info",
    size: "large",
    gapX: 10
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(NotificationList, {
    items: alerts
  })));
}

function Cheque(_ref) {
  var _plans$find, _plans$find$premium, _renderExpandedCards$, _renderExpandedCards$2, _renderExpandedCards$3, _values$cheque2;

  var data = _ref.data,
      renderExpandedCards = _ref.renderExpandedCards,
      planName = _ref.planName,
      planCode = _ref.planCode;
      _ref.ChequeTypeList;
  var params = useParams();
  var plan_name = planName ? planName : params === null || params === void 0 ? void 0 : params.plan_name;
  planCode ? planCode : params === null || params === void 0 ? void 0 : params.plan_code;

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first'
  });
      _useQuery.loading;
      _useQuery.error;
      var dataBuyPolicy = _useQuery.data;

  if (dataBuyPolicy) {
    var prembuyHealthPolicy = dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy;
    prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.quoteData;
    var premplanData = prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.planData;
    var plans = premplanData === null || premplanData === void 0 ? void 0 : premplanData.plans;
  }

  var Prem_data;
  Prem_data = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
    return p.name === plan_name;
  })) === null || _plans$find === void 0 ? void 0 : (_plans$find$premium = _plans$find.premium) === null || _plans$find$premium === void 0 ? void 0 : _plans$find$premium.totalPremium; // console.log('prem data cheque page',Prem_data)

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values,
      setFieldValue = _useQuantaFormikConte.setFieldValue;

  var _useContext = useContext(ConfigContext);
      _useContext.branding;

  var _useState = useState(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$ = renderExpandedCards.current) === null || _renderExpandedCards$ === void 0 ? void 0 : (_renderExpandedCards$2 = _renderExpandedCards$.filter(function (card) {
    var _card$cardName, _card$cardName$toStri, _card$cardName$toStri2;

    return card === null || card === void 0 ? void 0 : (_card$cardName = card.cardName) === null || _card$cardName === void 0 ? void 0 : (_card$cardName$toStri = _card$cardName.toString()) === null || _card$cardName$toStri === void 0 ? void 0 : (_card$cardName$toStri2 = _card$cardName$toStri.toLowerCase()) === null || _card$cardName$toStri2 === void 0 ? void 0 : _card$cardName$toStri2.startsWith('cheque');
  })) === null || _renderExpandedCards$2 === void 0 ? void 0 : (_renderExpandedCards$3 = _renderExpandedCards$2.sort(function (a, b) {
    var _a$cardName, _a$cardName$toString, _b$cardName, _b$cardName$toString, _a$cardName2, _a$cardName2$toString, _b$cardName2, _b$cardName2$toString;

    if ((a === null || a === void 0 ? void 0 : (_a$cardName = a.cardName) === null || _a$cardName === void 0 ? void 0 : (_a$cardName$toString = _a$cardName.toString()) === null || _a$cardName$toString === void 0 ? void 0 : _a$cardName$toString.toLowerCase()) < (b === null || b === void 0 ? void 0 : (_b$cardName = b.cardName) === null || _b$cardName === void 0 ? void 0 : (_b$cardName$toString = _b$cardName.toString()) === null || _b$cardName$toString === void 0 ? void 0 : _b$cardName$toString.toLowerCase())) {
      return -1;
    } else if ((a === null || a === void 0 ? void 0 : (_a$cardName2 = a.cardName) === null || _a$cardName2 === void 0 ? void 0 : (_a$cardName2$toString = _a$cardName2.toString()) === null || _a$cardName2$toString === void 0 ? void 0 : _a$cardName2$toString.toLowerCase()) > (b === null || b === void 0 ? void 0 : (_b$cardName2 = b.cardName) === null || _b$cardName2 === void 0 ? void 0 : (_b$cardName2$toString = _b$cardName2.toString()) === null || _b$cardName2$toString === void 0 ? void 0 : _b$cardName2$toString.toLowerCase())) {
      return 1;
    }

    return 0;
  })) === null || _renderExpandedCards$3 === void 0 ? void 0 : _renderExpandedCards$3.findIndex(function (card) {
    var _card$cardName2, _card$cardName2$toStr, _card$cardName2$toStr2;

    return (card === null || card === void 0 ? void 0 : (_card$cardName2 = card.cardName) === null || _card$cardName2 === void 0 ? void 0 : (_card$cardName2$toStr = _card$cardName2.toString()) === null || _card$cardName2$toStr === void 0 ? void 0 : (_card$cardName2$toStr2 = _card$cardName2$toStr.toLowerCase()) === null || _card$cardName2$toStr2 === void 0 ? void 0 : _card$cardName2$toStr2.startsWith('cheque')) && (card === null || card === void 0 ? void 0 : card.flag);
  })),
      _useState2 = _slicedToArray(_useState, 2),
      expandCard = _useState2[0],
      setExpandCard = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      ifscModalDisplay = _useState4[0],
      showIfscModal = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchStringIfsc = _useState6[0],
      setSearchStringIfsc = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      ifscCodeOutput = _useState8[0],
      setIfscCodeOutput = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      bankMetaMessage = _useState10[0],
      setBankMetaMessage = _useState10[1];

  var _useState11 = useState({
    ifsc: ''
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      errors = _useState12[0],
      setErrors = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      onDataUpdate = _useState14[0],
      setOnUpdate = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      loadingIfscModalDisplay = _useState16[0],
      setLoadingIfscModalDisplay = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      loadingIfscCodeData = _useState18[0],
      setLoadingIfscCodeData = _useState18[1];

  var fetchQuery = useFetchQuery();
  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });
  var changeInputType = useResponsiveParams({
    for_mobile: 'input-lookup',
    for_desktop: 'text'
  });
  var colSpanParams = useResponsiveParams({
    for_mobile: {
      searchString: 8,
      button: 2
    },
    for_desktop: {
      searchString: 4,
      button: 1
    }
  });
  var modalSizeExternal = useResponsiveParams({
    for_desktop: 'large',
    for_mobile: 'small',
    for_iPad: 'large'
  });
  useEffect(function () {
    if (loadingIfscModalDisplay.length === 0) {
      var _values$cheque;

      setLoadingIfscModalDisplay(values === null || values === void 0 ? void 0 : (_values$cheque = values.cheque) === null || _values$cheque === void 0 ? void 0 : _values$cheque.map(function (_) {
        return false;
      }));
    } else {
      setLoadingIfscModalDisplay([].concat(_toConsumableArray(loadingIfscModalDisplay), [false]));
    }
  }, [values === null || values === void 0 ? void 0 : (_values$cheque2 = values.cheque) === null || _values$cheque2 === void 0 ? void 0 : _values$cheque2.length]);

  var reformData = function reformData(val, returnType) {
    return val && val.toString().trim() !== '' ? val : returnType;
  };

  var onIfscSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, _) {
      var queryOutput, _yield$queryOutput, _data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(val.length > 0)) {
                _context.next = 20;
                break;
              }

              _context.prev = 1;
              setIfscCodeOutput([]);
              queryOutput = fetchQuery({
                query: CUSTOMER_BANK_DETAILS$1,
                variables: {
                  filter: {
                    ifscCode: val
                  }
                }
              });
              setLoadingIfscCodeData(true);
              _context.next = 7;
              return queryOutput;

            case 7:
              _yield$queryOutput = _context.sent;
              _data = _yield$queryOutput.data;
              setLoadingIfscCodeData(false);
              setIfscCodeOutput(_data.bankInfo);
              setBankMetaMessage(_data._bankInfo_meta.metaMessage);
              _context.next = 20;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                ifsc: _context.t0.message
              }));
              setLoadingIfscCodeData(false);
              setIfscCodeOutput([]);
              setBankMetaMessage(null);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    return function onIfscSearch(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var searchInput = {
    flow: 'cols',
    repeat: 5,
    data: changeInputType === 'text' ? [{
      type: 'text',
      name: 'searchString',
      size: 'full',
      colSpan: colSpanParams.searchString
    }, {
      type: 'submit',
      size: 'full',
      colSpan: colSpanParams.button,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSearch
      }),
      children: 'Search'
    }] : [{
      type: 'input-lookup',
      name: 'searchString',
      size: 'full',
      colSpan: colSpanParams.searchString,
      onLookup: onIfscSearch
    }],
    initialValues: {
      searchString: searchStringIfsc
    },
    validate: function validate(values) {
      var errors = {};
      if (!values.searchString) errors.searchString = '* Required';
      return errors;
    },
    onSearch: function () {
      var _onSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
        var queryOutput, _yield$queryOutput2, _data2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                setIfscCodeOutput([]);
                queryOutput = fetchQuery({
                  query: CUSTOMER_BANK_DETAILS$1,
                  variables: {
                    filter: {
                      ifscCode: values.searchString
                    }
                  }
                });
                setLoadingIfscCodeData(true);
                _context2.next = 6;
                return queryOutput;

              case 6:
                _yield$queryOutput2 = _context2.sent;
                _data2 = _yield$queryOutput2.data;
                setLoadingIfscCodeData(false);
                setIfscCodeOutput(_data2.bankInfo);
                setBankMetaMessage(_data2._bankInfo_meta.metaMessage);
                _context2.next = 19;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                  ifsc: _context2.t0.message
                }));
                setLoadingIfscCodeData(false);
                setIfscCodeOutput([]);
                setBankMetaMessage(null);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 13]]);
      }));

      function onSearch(_x3) {
        return _onSearch.apply(this, arguments);
      }

      return onSearch;
    }()
  };
  var searchResults = {
    data: ifscCodeOutput,
    onIdle: function onIdle() {
      if (loadingIfscCodeData) {
        return /*#__PURE__*/React.createElement(Loading, null);
      } else if (searchStringIfsc === '') {
        return /*#__PURE__*/React.createElement(IconIdle, null);
      }

      return undefined;
    },
    columns: [{
      Header: 'IFSC Code',
      accessor: 'ifsc_code'
    }, {
      Header: 'Bank Name',
      accessor: 'name'
    }, {
      Header: 'Branch Name',
      accessor: 'branch_name'
    }],
    list: ifscCodeOutput.map(function (data) {
      return {
        title: "".concat(data.ifsc_code),
        subtitle: "".concat(data.branch_name),
        onClick: function onClick() {
          onDataUpdate(data);
          showIfscModal(false);
          document.body.classList.remove('overflow-y-hidden');
        }
      };
    }),
    sortBy: {
      id: 'ifsc_code',
      desc: false
    }
  };

  var onClose = function onClose() {
    showIfscModal(false);
  };

  var onNoResultsFound = function onNoResultsFound() {
    return errors.ifsc;
  };

  var onMessage = function onMessage() {
    return bankMetaMessage && bankMetaMessage.type && bankMetaMessage.message && /*#__PURE__*/React.createElement(Text, {
      severity: bankMetaMessage.type,
      className: "space-x-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: bankMetaMessage.type === 'info' ? faExclamationCircle : bankMetaMessage.type === 'warning' ? faExclamationTriangle : faTimesCircle,
      className: "mr-1 text-".concat(bankMetaMessage.type)
    })), /*#__PURE__*/React.createElement("div", null, bankMetaMessage.message)));
  };

  var paginationInput = {
    offset: 0,
    PAGE_SIZE: 4
  }; // if (loading) {
  //   return (
  //     <div className="min-h-screen">
  //       <Loading />
  //     </div>
  //   );
  // }
  // if (error) {
  //   return <Error {...{ error }} />;
  // }
  //const { ChequeTypeList } = dropDownDetails;

  var gridData = values.cheque.flatMap(function (_, idx) {
    return [{
      title: "Cheque ".concat(idx + 1),
      expanded: expandCard === idx ? true : false,
      // expanded: renderExpandedCards?.current?.find(
      //   (card) =>
      //     card?.cardName?.toString()?.toLowerCase() ===
      //     `cheque ${idx + 1}`,
      // )?.flag,
      isToggleEnabled: true,
      controlExpanded: expandCard === idx ? true : false,
      // controlExpanded: renderExpandedCards?.current?.find(
      //   (card) =>
      //     card?.cardName?.toString()?.toLowerCase() ===
      //     `cheque ${idx + 1}`,
      // )?.flag,
      setExpandedCards: function setExpandedCards(expanded) {
        if (expanded) {
          var _renderExpandedCards$4, _renderExpandedCards$5, _renderExpandedCards$6, _renderExpandedCards$7;

          setExpandCard(idx);
          renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$4 = renderExpandedCards.current) === null || _renderExpandedCards$4 === void 0 ? void 0 : (_renderExpandedCards$5 = _renderExpandedCards$4.filter(function (card) {
            var _card$cardName3, _card$cardName3$toStr, _card$cardName4, _card$cardName4$toStr, _card$cardName4$toStr2;

            return (card === null || card === void 0 ? void 0 : (_card$cardName3 = card.cardName) === null || _card$cardName3 === void 0 ? void 0 : (_card$cardName3$toStr = _card$cardName3.toString()) === null || _card$cardName3$toStr === void 0 ? void 0 : _card$cardName3$toStr.toLowerCase()) !== "cheque ".concat(idx + 1) && (card === null || card === void 0 ? void 0 : (_card$cardName4 = card.cardName) === null || _card$cardName4 === void 0 ? void 0 : (_card$cardName4$toStr = _card$cardName4.toString()) === null || _card$cardName4$toStr === void 0 ? void 0 : (_card$cardName4$toStr2 = _card$cardName4$toStr.toLowerCase()) === null || _card$cardName4$toStr2 === void 0 ? void 0 : _card$cardName4$toStr2.startsWith('cheque'));
          })) === null || _renderExpandedCards$5 === void 0 ? void 0 : _renderExpandedCards$5.map(function (card) {
            return _objectSpread2(_objectSpread2({}, card), {}, {
              flag: false
            });
          })), _toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$6 = renderExpandedCards.current) === null || _renderExpandedCards$6 === void 0 ? void 0 : _renderExpandedCards$6.filter(function (card) {
            var _card$cardName5, _card$cardName5$toStr, _card$cardName5$toStr2;

            return !(card !== null && card !== void 0 && (_card$cardName5 = card.cardName) !== null && _card$cardName5 !== void 0 && (_card$cardName5$toStr = _card$cardName5.toString()) !== null && _card$cardName5$toStr !== void 0 && (_card$cardName5$toStr2 = _card$cardName5$toStr.toLowerCase()) !== null && _card$cardName5$toStr2 !== void 0 && _card$cardName5$toStr2.startsWith('cheque'));
          })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$7 = renderExpandedCards.current) === null || _renderExpandedCards$7 === void 0 ? void 0 : _renderExpandedCards$7.find(function (card) {
            var _card$cardName6, _card$cardName6$toStr;

            return (card === null || card === void 0 ? void 0 : (_card$cardName6 = card.cardName) === null || _card$cardName6 === void 0 ? void 0 : (_card$cardName6$toStr = _card$cardName6.toString()) === null || _card$cardName6$toStr === void 0 ? void 0 : _card$cardName6$toStr.toLowerCase()) === "cheque ".concat(idx + 1);
          })), {}, {
            flag: expanded
          })]);
        } else {
          var _renderExpandedCards$8, _renderExpandedCards$9;

          renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$8 = renderExpandedCards.current) === null || _renderExpandedCards$8 === void 0 ? void 0 : _renderExpandedCards$8.filter(function (card) {
            var _card$cardName7, _card$cardName7$toStr;

            return (card === null || card === void 0 ? void 0 : (_card$cardName7 = card.cardName) === null || _card$cardName7 === void 0 ? void 0 : (_card$cardName7$toStr = _card$cardName7.toString()) === null || _card$cardName7$toStr === void 0 ? void 0 : _card$cardName7$toStr.toLowerCase()) !== "cheque ".concat(idx + 1);
          })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$9 = renderExpandedCards.current) === null || _renderExpandedCards$9 === void 0 ? void 0 : _renderExpandedCards$9.find(function (card) {
            var _card$cardName8, _card$cardName8$toStr;

            return (card === null || card === void 0 ? void 0 : (_card$cardName8 = card.cardName) === null || _card$cardName8 === void 0 ? void 0 : (_card$cardName8$toStr = _card$cardName8.toString()) === null || _card$cardName8$toStr === void 0 ? void 0 : _card$cardName8$toStr.toLowerCase()) === "cheque ".concat(idx + 1);
          })), {}, {
            flag: expanded
          })]);
        }
      },
      grid_data: [{
        type: 'input-lookup',
        size: 'large',
        label: /*#__PURE__*/React.createElement("div", null, "IFSC Code ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: "cheque[".concat(idx, "].ifscCode"),
        loading: loadingIfscModalDisplay[idx],
        disabled: loadingIfscModalDisplay[idx] || ifscModalDisplay || (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy.isProposalApplicableForPayment) === false,
        onLookup: function () {
          var _onLookup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val, setFieldValue) {
            var queryOutput, _yield$queryOutput3, _data3;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(val.toString().length > 0)) {
                      _context3.next = 26;
                      break;
                    }

                    setOnUpdate(function (_) {
                      var newFunc = function newFunc(data) {
                        setFieldValue("cheque[".concat(idx, "].branchName"), reformData(data.branch_name, ''));
                        setFieldValue("cheque[".concat(idx, "].ifscCode"), reformData(data.ifsc_code, ''));
                        setFieldValue("cheque[".concat(idx, "].bankName"), reformData(data.name, ''));
                        setFieldValue("cheque[".concat(idx, "].branchLocation"), reformData(data.branch_address, ''));
                        setFieldValue("cheque[".concat(idx, "].bankCode"), reformData(data.bank_code, ''));
                        setFieldValue("cheque[".concat(idx, "].paymentAmount"), reformData(Prem_data, ''));
                      };

                      return newFunc;
                    });
                    setSearchStringIfsc(val);
                    _context3.prev = 3;
                    queryOutput = fetchQuery({
                      query: CUSTOMER_BANK_DETAILS$1,
                      variables: {
                        filter: {
                          ifscCode: val
                        }
                      }
                    });
                    setIfscCodeOutput([]);
                    setLoadingIfscModalDisplay([].concat(_toConsumableArray(loadingIfscModalDisplay.slice(0, idx)), [true], _toConsumableArray(loadingIfscModalDisplay.slice(idx + 1))));
                    showIfscModal(true);
                    setLoadingIfscModalDisplay([].concat(_toConsumableArray(loadingIfscModalDisplay.slice(0, idx)), [false], _toConsumableArray(loadingIfscModalDisplay.slice(idx + 1))));
                    setLoadingIfscCodeData(true);
                    _context3.next = 12;
                    return queryOutput;

                  case 12:
                    _yield$queryOutput3 = _context3.sent;
                    _data3 = _yield$queryOutput3.data;
                    setLoadingIfscCodeData(false);
                    setIfscCodeOutput(_data3.bankInfo);
                    _context3.next = 26;
                    break;

                  case 18:
                    _context3.prev = 18;
                    _context3.t0 = _context3["catch"](3);
                    setFieldValue("cheque[".concat(idx, "].branchName"), '');
                    setFieldValue("cheque[".concat(idx, "].bankName"), '');
                    setFieldValue("cheque[".concat(idx, "].branchLocation"), '');
                    setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                      ifsc: _context3.t0.message
                    }));
                    setLoadingIfscCodeData(false);
                    setIfscCodeOutput([]);

                  case 26:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[3, 18]]);
          }));

          function onLookup(_x4, _x5) {
            return _onLookup.apply(this, arguments);
          }

          return onLookup;
        }(),
        onDataChange: function onDataChange(_, setFieldValue) {
          setFieldValue("cheque[".concat(idx, "].bankName"), '');
        }
      }, {
        type: 'text',
        label: /*#__PURE__*/React.createElement("div", null, "Bank Name ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: true,
        name: "cheque[".concat(idx, "].bankName")
      }, {
        type: 'text',
        label: /*#__PURE__*/React.createElement("div", null, "Branch Name ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: true,
        name: "cheque[".concat(idx, "].branchName")
      }, {
        type: 'text',
        label: /*#__PURE__*/React.createElement("div", null, "Branch Location ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy.isProposalApplicableForPayment) === false,
        readOnly: true,
        name: "cheque[".concat(idx, "].branchLocation")
      }, // {
      //   type: 'select',
      //   label: (
      //     <div>
      //       Cheque Type <Text severity="error">*</Text>
      //     </div>
      //   ),
      //   name: `cheque[${idx}].chequeType`,
      //   data: ChequeTypeList
      //     ? [
      //         ...ChequeTypeList.map((chequeType) => {
      //           return {
      //             label: chequeType.value ? chequeType.value : '',
      //             value: chequeType.code ? chequeType.code : '',
      //           };
      //         }),
      //       ]
      //     : [],
      // },
      {
        type: 'number',
        min: 0,
        label: /*#__PURE__*/React.createElement("div", null, "Cheque Number ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy.isProposalApplicableForPayment) === false,
        name: "cheque[".concat(idx, "].chequeNumber")
      }, {
        type: 'date',
        maxdate: data === null || data === void 0 ? void 0 : data.maxDate,
        label: /*#__PURE__*/React.createElement("div", null, "Cheque Date ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy.isProposalApplicableForPayment) === false,
        name: "cheque[".concat(idx, "].chequeDate")
      }, {
        type: 'number',
        min: 0,
        iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faRupeeSign
        }),
        label: /*#__PURE__*/React.createElement("div", null, "Payment Amount ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy.isProposalApplicableForPayment) === false,
        name: "cheque[".concat(idx, "].paymentAmount")
      }, {
        type: 'render',
        component: function component() {
          return values.cheque.length > 1 && /*#__PURE__*/React.createElement("div", {
            className: "flex justify-end mt-7"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "button",
            className: "w-24 h-10",
            size: "small",
            onClick: function onClick(_) {
              var _values$cheque3, _renderExpandedCards$10, _renderExpandedCards$11, _renderExpandedCards$12;

              if (expandCard === (values === null || values === void 0 ? void 0 : (_values$cheque3 = values.cheque) === null || _values$cheque3 === void 0 ? void 0 : _values$cheque3.length) - 1) {
                var _values$cheque4;

                setExpandCard((values === null || values === void 0 ? void 0 : (_values$cheque4 = values.cheque) === null || _values$cheque4 === void 0 ? void 0 : _values$cheque4.length) - 2);
              }

              renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$10 = renderExpandedCards.current) === null || _renderExpandedCards$10 === void 0 ? void 0 : _renderExpandedCards$10.filter(function (card) {
                var _card$cardName9, _card$cardName9$toStr, _card$cardName9$toStr2, _card$cardName10, _card$cardName10$toSt, _card$cardName11, _card$cardName11$toSt, _card$cardName11$toSt2;

                return (card === null || card === void 0 ? void 0 : (_card$cardName9 = card.cardName) === null || _card$cardName9 === void 0 ? void 0 : (_card$cardName9$toStr = _card$cardName9.toString()) === null || _card$cardName9$toStr === void 0 ? void 0 : (_card$cardName9$toStr2 = _card$cardName9$toStr.toLowerCase()) === null || _card$cardName9$toStr2 === void 0 ? void 0 : _card$cardName9$toStr2.startsWith('cheque')) && parseInt(card === null || card === void 0 ? void 0 : (_card$cardName10 = card.cardName) === null || _card$cardName10 === void 0 ? void 0 : (_card$cardName10$toSt = _card$cardName10.toString()) === null || _card$cardName10$toSt === void 0 ? void 0 : _card$cardName10$toSt.split(' ')[1]) < idx + 1 || !(card !== null && card !== void 0 && (_card$cardName11 = card.cardName) !== null && _card$cardName11 !== void 0 && (_card$cardName11$toSt = _card$cardName11.toString()) !== null && _card$cardName11$toSt !== void 0 && (_card$cardName11$toSt2 = _card$cardName11$toSt.toLowerCase()) !== null && _card$cardName11$toSt2 !== void 0 && _card$cardName11$toSt2.startsWith('cheque'));
              })), _toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$11 = renderExpandedCards.current) === null || _renderExpandedCards$11 === void 0 ? void 0 : (_renderExpandedCards$12 = _renderExpandedCards$11.filter(function (card) {
                var _card$cardName12, _card$cardName12$toSt, _card$cardName12$toSt2, _card$cardName13, _card$cardName13$toSt;

                return (card === null || card === void 0 ? void 0 : (_card$cardName12 = card.cardName) === null || _card$cardName12 === void 0 ? void 0 : (_card$cardName12$toSt = _card$cardName12.toString()) === null || _card$cardName12$toSt === void 0 ? void 0 : (_card$cardName12$toSt2 = _card$cardName12$toSt.toLowerCase()) === null || _card$cardName12$toSt2 === void 0 ? void 0 : _card$cardName12$toSt2.startsWith('cheque')) && parseInt(card === null || card === void 0 ? void 0 : (_card$cardName13 = card.cardName) === null || _card$cardName13 === void 0 ? void 0 : (_card$cardName13$toSt = _card$cardName13.toString()) === null || _card$cardName13$toSt === void 0 ? void 0 : _card$cardName13$toSt.split(' ')[1]) > idx + 1;
              })) === null || _renderExpandedCards$12 === void 0 ? void 0 : _renderExpandedCards$12.map(function (card) {
                var _card$cardName14, _card$cardName14$toSt, _renderExpandedCards$13, _renderExpandedCards$14;

                return {
                  cardName: "cheque ".concat(parseInt(card === null || card === void 0 ? void 0 : (_card$cardName14 = card.cardName) === null || _card$cardName14 === void 0 ? void 0 : (_card$cardName14$toSt = _card$cardName14.toString()) === null || _card$cardName14$toSt === void 0 ? void 0 : _card$cardName14$toSt.split(' ')[1]) - 1),
                  flag: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$13 = renderExpandedCards.current) === null || _renderExpandedCards$13 === void 0 ? void 0 : (_renderExpandedCards$14 = _renderExpandedCards$13.find(function (c) {
                    var _c$cardName, _c$cardName$toString, _c$cardName$toString$, _c$cardName2, _c$cardName2$toString, _c$cardName2$toString2, _card$cardName15, _card$cardName15$toSt, _card$cardName15$toSt2;

                    return (c === null || c === void 0 ? void 0 : (_c$cardName = c.cardName) === null || _c$cardName === void 0 ? void 0 : (_c$cardName$toString = _c$cardName.toString()) === null || _c$cardName$toString === void 0 ? void 0 : (_c$cardName$toString$ = _c$cardName$toString.toLowerCase()) === null || _c$cardName$toString$ === void 0 ? void 0 : _c$cardName$toString$.startsWith('cheque')) && parseInt(c === null || c === void 0 ? void 0 : (_c$cardName2 = c.cardName) === null || _c$cardName2 === void 0 ? void 0 : (_c$cardName2$toString = _c$cardName2.toString()) === null || _c$cardName2$toString === void 0 ? void 0 : (_c$cardName2$toString2 = _c$cardName2$toString.toLowerCase()) === null || _c$cardName2$toString2 === void 0 ? void 0 : _c$cardName2$toString2.split(' ')[1]) === parseInt((card === null || card === void 0 ? void 0 : (_card$cardName15 = card.cardName) === null || _card$cardName15 === void 0 ? void 0 : (_card$cardName15$toSt = _card$cardName15.toString()) === null || _card$cardName15$toSt === void 0 ? void 0 : (_card$cardName15$toSt2 = _card$cardName15$toSt.toLowerCase()) === null || _card$cardName15$toSt2 === void 0 ? void 0 : _card$cardName15$toSt2.split(' ')[1]) - 1);
                  })) === null || _renderExpandedCards$14 === void 0 ? void 0 : _renderExpandedCards$14.flag
                };
              })));
              setFieldValue("cheque", [].concat(_toConsumableArray(values.cheque.slice(0, idx)), _toConsumableArray(values.cheque.slice(idx + 1))));
            }
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faTrashAlt
          }), /*#__PURE__*/React.createElement("span", {
            className: "ml-2"
          }, "Delete")));
        }
      }]
    }];
  });
  var other_props = {
    flow: 'cols',
    repeat: repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 4,
    size: 'full',
    useExpandablePaper: true,
    titleSeverity: 'info',
    textType: 'normal'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
    data: gridData
  }, other_props)), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end mt-3"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: "h-10",
    size: "small",
    iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faPlus,
      className: "mr-2"
    }),
    onClick: function onClick(_) {
      var _values$cheque5, _renderExpandedCards$15, _renderExpandedCards$16, _renderExpandedCards$17, _renderExpandedCards$18, _values$cheque6;

      setExpandCard(values === null || values === void 0 ? void 0 : (_values$cheque5 = values.cheque) === null || _values$cheque5 === void 0 ? void 0 : _values$cheque5.length);
      renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$15 = renderExpandedCards.current) === null || _renderExpandedCards$15 === void 0 ? void 0 : (_renderExpandedCards$16 = _renderExpandedCards$15.filter(function (card) {
        var _card$cardName16, _card$cardName16$toSt, _card$cardName16$toSt2;

        return card === null || card === void 0 ? void 0 : (_card$cardName16 = card.cardName) === null || _card$cardName16 === void 0 ? void 0 : (_card$cardName16$toSt = _card$cardName16.toString()) === null || _card$cardName16$toSt === void 0 ? void 0 : (_card$cardName16$toSt2 = _card$cardName16$toSt.toLowerCase()) === null || _card$cardName16$toSt2 === void 0 ? void 0 : _card$cardName16$toSt2.startsWith('cheque');
      })) === null || _renderExpandedCards$16 === void 0 ? void 0 : _renderExpandedCards$16.map(function (card) {
        return _objectSpread2(_objectSpread2({}, card), {}, {
          flag: false
        });
      })), _toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$17 = renderExpandedCards.current) === null || _renderExpandedCards$17 === void 0 ? void 0 : _renderExpandedCards$17.filter(function (card) {
        var _card$cardName17, _card$cardName17$toSt, _card$cardName17$toSt2;

        return !(card !== null && card !== void 0 && (_card$cardName17 = card.cardName) !== null && _card$cardName17 !== void 0 && (_card$cardName17$toSt = _card$cardName17.toString()) !== null && _card$cardName17$toSt !== void 0 && (_card$cardName17$toSt2 = _card$cardName17$toSt.toLowerCase()) !== null && _card$cardName17$toSt2 !== void 0 && _card$cardName17$toSt2.startsWith('cheque'));
      })));
      renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$18 = renderExpandedCards.current) === null || _renderExpandedCards$18 === void 0 ? void 0 : _renderExpandedCards$18.push({
        cardName: "cheque ".concat((values === null || values === void 0 ? void 0 : (_values$cheque6 = values.cheque) === null || _values$cheque6 === void 0 ? void 0 : _values$cheque6.length) + 1),
        flag: true
      });
      setFieldValue("cheque", [].concat(_toConsumableArray(values.cheque), [{
        ifscCode: '',
        bankName: '',
        chequeType: '',
        chequeNumber: '',
        chequeDate: data === null || data === void 0 ? void 0 : data.maxDate,
        paymentAmount: '',
        branchName: '',
        branchLocation: ''
      }]));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-sm"
  }, "Add Cheque")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchResultsModal, {
    modalSizeExternal: modalSizeExternal,
    modalDisplay: ifscModalDisplay,
    isFormWrapFlag: true,
    searchInput: searchInput,
    searchResults: searchResults,
    paginationInput: paginationInput,
    title: 'Search IFSC Code',
    onClose: onClose,
    onDataUpdate: onDataUpdate,
    onNoResultsFound: onNoResultsFound,
    onMessage: onMessage,
    selectOnRowClick: true,
    firstRowClickRequired: false
  })));
}

function DemandDraft(_ref) {
  var _plans$find, _plans$find$premium, _renderExpandedCards$, _renderExpandedCards$2, _renderExpandedCards$3;

  var data = _ref.data,
      renderExpandedCards = _ref.renderExpandedCards;
  var params = useParams();
  var plan_name = params === null || params === void 0 ? void 0 : params.plan_name;
  params === null || params === void 0 ? void 0 : params.plan_code;

  var _useQuery = useQuery(GET_BUY_HEALTH_POLICY_VAR_DETAILS, {
    fetchPolicy: 'cache-first'
  });
      _useQuery.loading;
      _useQuery.error;
      var dataBuyPolicy = _useQuery.data;

  if (dataBuyPolicy) {
    var prembuyHealthPolicy = dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : dataBuyPolicy.buyHealthPolicy;
    prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.quoteData;
    var premplanData = prembuyHealthPolicy === null || prembuyHealthPolicy === void 0 ? void 0 : prembuyHealthPolicy.planData;
    var plans = premplanData === null || premplanData === void 0 ? void 0 : premplanData.plans;
  }

  var Prem_data;
  Prem_data = plans === null || plans === void 0 ? void 0 : (_plans$find = plans.find(function (p) {
    return p.name === plan_name;
  })) === null || _plans$find === void 0 ? void 0 : (_plans$find$premium = _plans$find.premium) === null || _plans$find$premium === void 0 ? void 0 : _plans$find$premium.totalPremium; //console.log('prem data DD page',Prem_data)

  var _useQuantaFormikConte = useQuantaFormikContext(),
      values = _useQuantaFormikConte.values,
      setFieldValue = _useQuantaFormikConte.setFieldValue;

  var _useContext = useContext(ConfigContext);
      _useContext.branding;

  var _useState = useState(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$ = renderExpandedCards.current) === null || _renderExpandedCards$ === void 0 ? void 0 : (_renderExpandedCards$2 = _renderExpandedCards$.filter(function (card) {
    var _card$cardName, _card$cardName$toStri, _card$cardName$toStri2;

    return card === null || card === void 0 ? void 0 : (_card$cardName = card.cardName) === null || _card$cardName === void 0 ? void 0 : (_card$cardName$toStri = _card$cardName.toString()) === null || _card$cardName$toStri === void 0 ? void 0 : (_card$cardName$toStri2 = _card$cardName$toStri.toLowerCase()) === null || _card$cardName$toStri2 === void 0 ? void 0 : _card$cardName$toStri2.startsWith('dd');
  })) === null || _renderExpandedCards$2 === void 0 ? void 0 : (_renderExpandedCards$3 = _renderExpandedCards$2.sort(function (a, b) {
    var _a$cardName, _a$cardName$toString, _b$cardName, _b$cardName$toString, _a$cardName2, _a$cardName2$toString, _b$cardName2, _b$cardName2$toString;

    if ((a === null || a === void 0 ? void 0 : (_a$cardName = a.cardName) === null || _a$cardName === void 0 ? void 0 : (_a$cardName$toString = _a$cardName.toString()) === null || _a$cardName$toString === void 0 ? void 0 : _a$cardName$toString.toLowerCase()) < (b === null || b === void 0 ? void 0 : (_b$cardName = b.cardName) === null || _b$cardName === void 0 ? void 0 : (_b$cardName$toString = _b$cardName.toString()) === null || _b$cardName$toString === void 0 ? void 0 : _b$cardName$toString.toLowerCase())) {
      return -1;
    } else if ((a === null || a === void 0 ? void 0 : (_a$cardName2 = a.cardName) === null || _a$cardName2 === void 0 ? void 0 : (_a$cardName2$toString = _a$cardName2.toString()) === null || _a$cardName2$toString === void 0 ? void 0 : _a$cardName2$toString.toLowerCase()) > (b === null || b === void 0 ? void 0 : (_b$cardName2 = b.cardName) === null || _b$cardName2 === void 0 ? void 0 : (_b$cardName2$toString = _b$cardName2.toString()) === null || _b$cardName2$toString === void 0 ? void 0 : _b$cardName2$toString.toLowerCase())) {
      return 1;
    }

    return 0;
  })) === null || _renderExpandedCards$3 === void 0 ? void 0 : _renderExpandedCards$3.findIndex(function (card) {
    var _card$cardName2, _card$cardName2$toStr, _card$cardName2$toStr2;

    return (card === null || card === void 0 ? void 0 : (_card$cardName2 = card.cardName) === null || _card$cardName2 === void 0 ? void 0 : (_card$cardName2$toStr = _card$cardName2.toString()) === null || _card$cardName2$toStr === void 0 ? void 0 : (_card$cardName2$toStr2 = _card$cardName2$toStr.toLowerCase()) === null || _card$cardName2$toStr2 === void 0 ? void 0 : _card$cardName2$toStr2.startsWith('dd')) && (card === null || card === void 0 ? void 0 : card.flag);
  })),
      _useState2 = _slicedToArray(_useState, 2),
      expandCard = _useState2[0],
      setExpandCard = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      ifscModalDisplay = _useState4[0],
      showIfscModal = _useState4[1];

  var _useState5 = useState(''),
      _useState6 = _slicedToArray(_useState5, 2),
      searchStringIfsc = _useState6[0],
      setSearchStringIfsc = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      ifscCodeOutput = _useState8[0],
      setIfscCodeOutput = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      bankMetaMessage = _useState10[0],
      setBankMetaMessage = _useState10[1];

  var _useState11 = useState({
    ifsc: ''
  }),
      _useState12 = _slicedToArray(_useState11, 2),
      errors = _useState12[0],
      setErrors = _useState12[1];

  var _useState13 = useState(null),
      _useState14 = _slicedToArray(_useState13, 2),
      onDataUpdate = _useState14[0],
      setOnUpdate = _useState14[1];

  var _useState15 = useState([]),
      _useState16 = _slicedToArray(_useState15, 2),
      loadingIfscModalDisplay = _useState16[0],
      setLoadingIfscModalDisplay = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      loadingIfscCodeData = _useState18[0],
      setLoadingIfscCodeData = _useState18[1];

  var fetchQuery = useFetchQuery();
  var repeat = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3
  });
  var changeInputType = useResponsiveParams({
    for_mobile: 'input-lookup',
    for_desktop: 'text'
  });
  var colSpanParams = useResponsiveParams({
    for_mobile: {
      searchString: 8,
      button: 2
    },
    for_desktop: {
      searchString: 4,
      button: 1
    }
  });
  var modalSizeExternal = useResponsiveParams({
    for_desktop: 'large',
    for_mobile: 'small',
    for_iPad: 'large'
  });
  useEffect(function () {
    if (loadingIfscModalDisplay.length === 0) {
      setLoadingIfscModalDisplay(values.demandDraft.map(function (_) {
        return false;
      }));
    } else {
      setLoadingIfscModalDisplay([].concat(_toConsumableArray(loadingIfscModalDisplay), [false]));
    }
  }, [values.demandDraft.length]);

  var reformData = function reformData(val, returnType) {
    return val && val.toString().trim() !== '' ? val : returnType;
  };

  var onIfscSearch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(val, _) {
      var queryOutput, _yield$queryOutput, _data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(val.length > 0)) {
                _context.next = 20;
                break;
              }

              _context.prev = 1;
              setIfscCodeOutput([]);
              queryOutput = fetchQuery({
                query: CUSTOMER_BANK_DETAILS$1,
                variables: {
                  filter: {
                    ifscCode: val
                  }
                }
              });
              setLoadingIfscCodeData(true);
              _context.next = 7;
              return queryOutput;

            case 7:
              _yield$queryOutput = _context.sent;
              _data = _yield$queryOutput.data;
              setLoadingIfscCodeData(false);
              setIfscCodeOutput(_data.bankInfo);
              setBankMetaMessage(_data._bankInfo_meta.metaMessage);
              _context.next = 20;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](1);
              setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                ifsc: _context.t0.message
              }));
              setLoadingIfscCodeData(false);
              setIfscCodeOutput([]);
              setBankMetaMessage(null);

            case 20:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 14]]);
    }));

    return function onIfscSearch(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var searchInput = {
    flow: 'cols',
    repeat: 5,
    data: changeInputType === 'text' ? [{
      type: 'text',
      name: 'searchString',
      size: 'full',
      colSpan: colSpanParams.searchString
    }, {
      type: 'submit',
      size: 'full',
      colSpan: colSpanParams.button,
      iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
        icon: faSearch
      }),
      children: 'Search'
    }] : [{
      type: 'input-lookup',
      name: 'searchString',
      size: 'full',
      colSpan: colSpanParams.searchString,
      onLookup: onIfscSearch
    }],
    initialValues: {
      searchString: searchStringIfsc
    },
    validate: function validate(values) {
      var errors = {};
      if (!values.searchString) errors.searchString = '* Required';
      return errors;
    },
    onSearch: function () {
      var _onSearch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(values) {
        var queryOutput, _yield$queryOutput2, _data2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                setIfscCodeOutput([]);
                queryOutput = fetchQuery({
                  query: CUSTOMER_BANK_DETAILS$1,
                  variables: {
                    filter: {
                      ifscCode: values.searchString
                    }
                  }
                });
                setLoadingIfscCodeData(true);
                _context2.next = 6;
                return queryOutput;

              case 6:
                _yield$queryOutput2 = _context2.sent;
                _data2 = _yield$queryOutput2.data;
                setLoadingIfscCodeData(false);
                setIfscCodeOutput(_data2.bankInfo);
                setBankMetaMessage(_data2._bankInfo_meta.metaMessage);
                _context2.next = 19;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](0);
                setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                  ifsc: _context2.t0.message
                }));
                setLoadingIfscCodeData(false);
                setIfscCodeOutput([]);
                setBankMetaMessage(null);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 13]]);
      }));

      function onSearch(_x3) {
        return _onSearch.apply(this, arguments);
      }

      return onSearch;
    }()
  };
  var searchResults = {
    data: ifscCodeOutput,
    onIdle: function onIdle() {
      if (loadingIfscCodeData) {
        return /*#__PURE__*/React.createElement(Loading, null);
      } else if (searchStringIfsc === '') {
        return /*#__PURE__*/React.createElement(IconIdle, null);
      }

      return undefined;
    },
    columns: [{
      Header: 'IFSC Code',
      accessor: 'ifsc_code'
    }, {
      Header: 'Bank Name',
      accessor: 'name'
    }, {
      Header: 'Branch Name',
      accessor: 'branch_name'
    }],
    list: ifscCodeOutput.map(function (data) {
      return {
        title: "".concat(data.ifsc_code),
        subtitle: "".concat(data.branch_name),
        onClick: function onClick() {
          onDataUpdate(data);
          showIfscModal(false);
          document.body.classList.remove('overflow-y-hidden');
        }
      };
    }),
    sortBy: {
      id: 'ifsc_code',
      desc: false
    }
  };

  var onClose = function onClose() {
    showIfscModal(false);
  };

  var onNoResultsFound = function onNoResultsFound() {
    return errors.ifsc;
  };

  var onMessage = function onMessage() {
    return bankMetaMessage && bankMetaMessage.type && bankMetaMessage.message && /*#__PURE__*/React.createElement(Text, {
      severity: bankMetaMessage.type,
      className: "space-x-1"
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex flex-row"
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: bankMetaMessage.type === 'info' ? faExclamationCircle : bankMetaMessage.type === 'warning' ? faExclamationTriangle : faTimesCircle,
      className: "mr-1 text-".concat(bankMetaMessage.type)
    })), /*#__PURE__*/React.createElement("div", null, bankMetaMessage.message)));
  };

  var paginationInput = {
    offset: 0,
    PAGE_SIZE: 4
  };
  var gridData = values.demandDraft.flatMap(function (_, idx) {
    var _dataBuyPolicy$buyHea, _dataBuyPolicy$buyHea2, _dataBuyPolicy$buyHea3, _dataBuyPolicy$buyHea4, _dataBuyPolicy$buyHea5;

    return [{
      title: "Demand Draft ".concat(idx + 1),
      expanded: expandCard === idx ? true : false,
      // expanded: renderExpandedCards?.current?.find(
      //   (card) =>
      //     card?.cardName?.toString()?.toLowerCase() ===
      //     `dd ${dd + 1}`,
      // )?.flag,
      isToggleEnabled: true,
      controlExpanded: expandCard === idx ? true : false,
      // controlExpanded: renderExpandedCards?.current?.find(
      //   (card) =>
      //     card?.cardName?.toString()?.toLowerCase() ===
      //     `dd ${dd + 1}`,
      // )?.flag,
      setExpandedCards: function setExpandedCards(expanded) {
        if (expanded) {
          var _renderExpandedCards$4, _renderExpandedCards$5, _renderExpandedCards$6, _renderExpandedCards$7;

          setExpandCard(idx);
          renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$4 = renderExpandedCards.current) === null || _renderExpandedCards$4 === void 0 ? void 0 : (_renderExpandedCards$5 = _renderExpandedCards$4.filter(function (card) {
            var _card$cardName3, _card$cardName3$toStr, _card$cardName4, _card$cardName4$toStr, _card$cardName4$toStr2;

            return (card === null || card === void 0 ? void 0 : (_card$cardName3 = card.cardName) === null || _card$cardName3 === void 0 ? void 0 : (_card$cardName3$toStr = _card$cardName3.toString()) === null || _card$cardName3$toStr === void 0 ? void 0 : _card$cardName3$toStr.toLowerCase()) !== "dd ".concat(idx + 1) && (card === null || card === void 0 ? void 0 : (_card$cardName4 = card.cardName) === null || _card$cardName4 === void 0 ? void 0 : (_card$cardName4$toStr = _card$cardName4.toString()) === null || _card$cardName4$toStr === void 0 ? void 0 : (_card$cardName4$toStr2 = _card$cardName4$toStr.toLowerCase()) === null || _card$cardName4$toStr2 === void 0 ? void 0 : _card$cardName4$toStr2.startsWith('dd'));
          })) === null || _renderExpandedCards$5 === void 0 ? void 0 : _renderExpandedCards$5.map(function (card) {
            return _objectSpread2(_objectSpread2({}, card), {}, {
              flag: false
            });
          })), _toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$6 = renderExpandedCards.current) === null || _renderExpandedCards$6 === void 0 ? void 0 : _renderExpandedCards$6.filter(function (card) {
            var _card$cardName5, _card$cardName5$toStr, _card$cardName5$toStr2;

            return !(card !== null && card !== void 0 && (_card$cardName5 = card.cardName) !== null && _card$cardName5 !== void 0 && (_card$cardName5$toStr = _card$cardName5.toString()) !== null && _card$cardName5$toStr !== void 0 && (_card$cardName5$toStr2 = _card$cardName5$toStr.toLowerCase()) !== null && _card$cardName5$toStr2 !== void 0 && _card$cardName5$toStr2.startsWith('dd'));
          })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$7 = renderExpandedCards.current) === null || _renderExpandedCards$7 === void 0 ? void 0 : _renderExpandedCards$7.find(function (card) {
            var _card$cardName6, _card$cardName6$toStr;

            return (card === null || card === void 0 ? void 0 : (_card$cardName6 = card.cardName) === null || _card$cardName6 === void 0 ? void 0 : (_card$cardName6$toStr = _card$cardName6.toString()) === null || _card$cardName6$toStr === void 0 ? void 0 : _card$cardName6$toStr.toLowerCase()) === "dd ".concat(idx + 1);
          })), {}, {
            flag: expanded
          })]);
        } else {
          var _renderExpandedCards$8, _renderExpandedCards$9;

          renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$8 = renderExpandedCards.current) === null || _renderExpandedCards$8 === void 0 ? void 0 : _renderExpandedCards$8.filter(function (card) {
            var _card$cardName7, _card$cardName7$toStr;

            return (card === null || card === void 0 ? void 0 : (_card$cardName7 = card.cardName) === null || _card$cardName7 === void 0 ? void 0 : (_card$cardName7$toStr = _card$cardName7.toString()) === null || _card$cardName7$toStr === void 0 ? void 0 : _card$cardName7$toStr.toLowerCase()) !== "dd ".concat(idx + 1);
          })), [_objectSpread2(_objectSpread2({}, renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$9 = renderExpandedCards.current) === null || _renderExpandedCards$9 === void 0 ? void 0 : _renderExpandedCards$9.find(function (card) {
            var _card$cardName8, _card$cardName8$toStr;

            return (card === null || card === void 0 ? void 0 : (_card$cardName8 = card.cardName) === null || _card$cardName8 === void 0 ? void 0 : (_card$cardName8$toStr = _card$cardName8.toString()) === null || _card$cardName8$toStr === void 0 ? void 0 : _card$cardName8$toStr.toLowerCase()) === "dd ".concat(idx + 1);
          })), {}, {
            flag: expanded
          })]);
        }
      },
      grid_data: [{
        type: 'input-lookup',
        size: 'large',
        label: /*#__PURE__*/React.createElement("div", null, "IFSC Code ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: "demandDraft[".concat(idx, "].ifscCode"),
        loading: loadingIfscModalDisplay[idx],
        disabled: loadingIfscModalDisplay[idx] || ifscModalDisplay || (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea === void 0 ? void 0 : _dataBuyPolicy$buyHea.isProposalApplicableForPayment) === false,
        onLookup: function () {
          var _onLookup = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(val, setFieldValue) {
            var queryOutput, _yield$queryOutput3, _data3;

            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    if (!(val.toString().length > 0)) {
                      _context3.next = 26;
                      break;
                    }

                    setOnUpdate(function (_) {
                      var newFunc = function newFunc(data) {
                        setFieldValue("demandDraft[".concat(idx, "].branchName"), reformData(data.branch_name, ''));
                        setFieldValue("demandDraft[".concat(idx, "].ifscCode"), reformData(data.ifsc_code, ''));
                        setFieldValue("demandDraft[".concat(idx, "].bankName"), reformData(data.name, ''));
                        setFieldValue("demandDraft[".concat(idx, "].branchLocation"), reformData(data.branch_address, ''));
                        setFieldValue("demandDraft[".concat(idx, "].bankCode"), reformData(data.bank_code, ''));
                        setFieldValue("demandDraft[".concat(idx, "].paymentAmount"), reformData(Prem_data, ''));
                      };

                      return newFunc;
                    });
                    setSearchStringIfsc(val);
                    _context3.prev = 3;
                    queryOutput = fetchQuery({
                      query: CUSTOMER_BANK_DETAILS$1,
                      variables: {
                        filter: {
                          ifscCode: val
                        }
                      }
                    });
                    setIfscCodeOutput([]);
                    setLoadingIfscModalDisplay([].concat(_toConsumableArray(loadingIfscModalDisplay.slice(0, idx)), [true], _toConsumableArray(loadingIfscModalDisplay.slice(idx + 1))));
                    showIfscModal(true);
                    setLoadingIfscModalDisplay([].concat(_toConsumableArray(loadingIfscModalDisplay.slice(0, idx)), [false], _toConsumableArray(loadingIfscModalDisplay.slice(idx + 1))));
                    setLoadingIfscCodeData(true);
                    _context3.next = 12;
                    return queryOutput;

                  case 12:
                    _yield$queryOutput3 = _context3.sent;
                    _data3 = _yield$queryOutput3.data;
                    setLoadingIfscCodeData(false);
                    setIfscCodeOutput(_data3.bankInfo);
                    _context3.next = 26;
                    break;

                  case 18:
                    _context3.prev = 18;
                    _context3.t0 = _context3["catch"](3);
                    setFieldValue("demandDraft[".concat(idx, "].branchName"), '');
                    setFieldValue("demandDraft[".concat(idx, "].bankName"), '');
                    setFieldValue("demandDraft[".concat(idx, "].branchLocation"), '');
                    setErrors(_objectSpread2(_objectSpread2({}, errors), {}, {
                      ifsc: _context3.t0.message
                    }));
                    setLoadingIfscCodeData(false);
                    setIfscCodeOutput([]);

                  case 26:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3, null, [[3, 18]]);
          }));

          function onLookup(_x4, _x5) {
            return _onLookup.apply(this, arguments);
          }

          return onLookup;
        }(),
        onDataChange: function onDataChange(_, setFieldValue) {
          setFieldValue("demandDraft[".concat(idx, "].bankName"), '');
        }
      }, {
        type: 'text',
        label: /*#__PURE__*/React.createElement("div", null, "Bank Name ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: true,
        name: "demandDraft[".concat(idx, "].bankName")
      }, {
        type: 'text',
        label: /*#__PURE__*/React.createElement("div", null, "Branch Name ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        disabled: true,
        name: "demandDraft[".concat(idx, "].branchName")
      }, {
        type: 'text',
        label: /*#__PURE__*/React.createElement("div", null, "Branch Location ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        readOnly: true,
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea2 = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea2 === void 0 ? void 0 : _dataBuyPolicy$buyHea2.isProposalApplicableForPayment) === false,
        name: "demandDraft[".concat(idx, "].branchLocation")
      }, {
        type: 'number',
        min: 0,
        label: /*#__PURE__*/React.createElement("div", null, "DD Number ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: "demandDraft[".concat(idx, "].ddNumber"),
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea3 = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea3 === void 0 ? void 0 : _dataBuyPolicy$buyHea3.isProposalApplicableForPayment) === false
      }, {
        type: 'date',
        maxdate: data === null || data === void 0 ? void 0 : data.maxDate,
        label: /*#__PURE__*/React.createElement("div", null, "DD Date ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: "demandDraft[".concat(idx, "].ddDate"),
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea4 = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea4 === void 0 ? void 0 : _dataBuyPolicy$buyHea4.isProposalApplicableForPayment) === false
      }, {
        type: 'number',
        min: 0,
        iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
          icon: faRupeeSign
        }),
        label: /*#__PURE__*/React.createElement("div", null, "Payment Amount ", /*#__PURE__*/React.createElement(Text, {
          severity: "error"
        }, "*")),
        name: "demandDraft[".concat(idx, "].paymentAmount"),
        disabled: (dataBuyPolicy === null || dataBuyPolicy === void 0 ? void 0 : (_dataBuyPolicy$buyHea5 = dataBuyPolicy.buyHealthPolicy) === null || _dataBuyPolicy$buyHea5 === void 0 ? void 0 : _dataBuyPolicy$buyHea5.isProposalApplicableForPayment) === false
      }, {
        type: 'render',
        component: function component() {
          return /*#__PURE__*/React.createElement(React.Fragment, null);
        }
      }, {
        type: 'render',
        component: function component() {
          return values.demandDraft.length > 1 && /*#__PURE__*/React.createElement("div", {
            className: "flex justify-end mt-7"
          }, /*#__PURE__*/React.createElement(Button, {
            type: "button",
            className: "w-20 h-10",
            size: "small",
            onClick: function onClick(_) {
              var _values$demandDraft, _renderExpandedCards$10, _renderExpandedCards$11, _renderExpandedCards$12;

              if (expandCard === (values === null || values === void 0 ? void 0 : (_values$demandDraft = values.demandDraft) === null || _values$demandDraft === void 0 ? void 0 : _values$demandDraft.length) - 1) {
                var _values$demandDraft2;

                setExpandCard((values === null || values === void 0 ? void 0 : (_values$demandDraft2 = values.demandDraft) === null || _values$demandDraft2 === void 0 ? void 0 : _values$demandDraft2.length) - 2);
              }

              renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$10 = renderExpandedCards.current) === null || _renderExpandedCards$10 === void 0 ? void 0 : _renderExpandedCards$10.filter(function (card) {
                var _card$cardName9, _card$cardName9$toStr, _card$cardName9$toStr2, _card$cardName10, _card$cardName10$toSt, _card$cardName11, _card$cardName11$toSt, _card$cardName11$toSt2;

                return (card === null || card === void 0 ? void 0 : (_card$cardName9 = card.cardName) === null || _card$cardName9 === void 0 ? void 0 : (_card$cardName9$toStr = _card$cardName9.toString()) === null || _card$cardName9$toStr === void 0 ? void 0 : (_card$cardName9$toStr2 = _card$cardName9$toStr.toLowerCase()) === null || _card$cardName9$toStr2 === void 0 ? void 0 : _card$cardName9$toStr2.startsWith('dd')) && parseInt(card === null || card === void 0 ? void 0 : (_card$cardName10 = card.cardName) === null || _card$cardName10 === void 0 ? void 0 : (_card$cardName10$toSt = _card$cardName10.toString()) === null || _card$cardName10$toSt === void 0 ? void 0 : _card$cardName10$toSt.split(' ')[1]) < idx + 1 || !(card !== null && card !== void 0 && (_card$cardName11 = card.cardName) !== null && _card$cardName11 !== void 0 && (_card$cardName11$toSt = _card$cardName11.toString()) !== null && _card$cardName11$toSt !== void 0 && (_card$cardName11$toSt2 = _card$cardName11$toSt.toLowerCase()) !== null && _card$cardName11$toSt2 !== void 0 && _card$cardName11$toSt2.startsWith('dd'));
              })), _toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$11 = renderExpandedCards.current) === null || _renderExpandedCards$11 === void 0 ? void 0 : (_renderExpandedCards$12 = _renderExpandedCards$11.filter(function (card) {
                var _card$cardName12, _card$cardName12$toSt, _card$cardName12$toSt2, _card$cardName13, _card$cardName13$toSt;

                return (card === null || card === void 0 ? void 0 : (_card$cardName12 = card.cardName) === null || _card$cardName12 === void 0 ? void 0 : (_card$cardName12$toSt = _card$cardName12.toString()) === null || _card$cardName12$toSt === void 0 ? void 0 : (_card$cardName12$toSt2 = _card$cardName12$toSt.toLowerCase()) === null || _card$cardName12$toSt2 === void 0 ? void 0 : _card$cardName12$toSt2.startsWith('dd')) && parseInt(card === null || card === void 0 ? void 0 : (_card$cardName13 = card.cardName) === null || _card$cardName13 === void 0 ? void 0 : (_card$cardName13$toSt = _card$cardName13.toString()) === null || _card$cardName13$toSt === void 0 ? void 0 : _card$cardName13$toSt.split(' ')[1]) > idx + 1;
              })) === null || _renderExpandedCards$12 === void 0 ? void 0 : _renderExpandedCards$12.map(function (card) {
                var _card$cardName14, _card$cardName14$toSt, _renderExpandedCards$13, _renderExpandedCards$14;

                return {
                  cardName: "dd ".concat(parseInt(card === null || card === void 0 ? void 0 : (_card$cardName14 = card.cardName) === null || _card$cardName14 === void 0 ? void 0 : (_card$cardName14$toSt = _card$cardName14.toString()) === null || _card$cardName14$toSt === void 0 ? void 0 : _card$cardName14$toSt.split(' ')[1]) - 1),
                  flag: renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$13 = renderExpandedCards.current) === null || _renderExpandedCards$13 === void 0 ? void 0 : (_renderExpandedCards$14 = _renderExpandedCards$13.find(function (c) {
                    var _c$cardName, _c$cardName$toString, _c$cardName$toString$, _c$cardName2, _c$cardName2$toString, _c$cardName2$toString2, _card$cardName15, _card$cardName15$toSt, _card$cardName15$toSt2;

                    return (c === null || c === void 0 ? void 0 : (_c$cardName = c.cardName) === null || _c$cardName === void 0 ? void 0 : (_c$cardName$toString = _c$cardName.toString()) === null || _c$cardName$toString === void 0 ? void 0 : (_c$cardName$toString$ = _c$cardName$toString.toLowerCase()) === null || _c$cardName$toString$ === void 0 ? void 0 : _c$cardName$toString$.startsWith('dd')) && parseInt(c === null || c === void 0 ? void 0 : (_c$cardName2 = c.cardName) === null || _c$cardName2 === void 0 ? void 0 : (_c$cardName2$toString = _c$cardName2.toString()) === null || _c$cardName2$toString === void 0 ? void 0 : (_c$cardName2$toString2 = _c$cardName2$toString.toLowerCase()) === null || _c$cardName2$toString2 === void 0 ? void 0 : _c$cardName2$toString2.split(' ')[1]) === parseInt((card === null || card === void 0 ? void 0 : (_card$cardName15 = card.cardName) === null || _card$cardName15 === void 0 ? void 0 : (_card$cardName15$toSt = _card$cardName15.toString()) === null || _card$cardName15$toSt === void 0 ? void 0 : (_card$cardName15$toSt2 = _card$cardName15$toSt.toLowerCase()) === null || _card$cardName15$toSt2 === void 0 ? void 0 : _card$cardName15$toSt2.split(' ')[1]) - 1);
                  })) === null || _renderExpandedCards$14 === void 0 ? void 0 : _renderExpandedCards$14.flag
                };
              })));
              setFieldValue("demandDraft", [].concat(_toConsumableArray(values.demandDraft.slice(0, idx)), _toConsumableArray(values.demandDraft.slice(idx + 1))));
            }
          }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
            icon: faTrashAlt,
            className: "text-sm"
          }), /*#__PURE__*/React.createElement("span", {
            className: "ml-2 text-sm"
          }, "Delete")));
        }
      }]
    }];
  });
  var other_props = {
    flow: 'cols',
    repeat: repeat,
    gapX: 6,
    gapY: 0,
    spaceY: 4,
    size: 'full',
    useExpandablePaper: true,
    titleSeverity: 'info',
    textType: 'normal'
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(QuantaForm, null, /*#__PURE__*/React.createElement(MixedGridGroup, _objectSpread2({
    data: gridData
  }, other_props)), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-end mt-3"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    className: "h-10",
    size: "small",
    iconPre: /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: faPlus,
      className: "mr-2"
    }),
    onClick: function onClick(_) {
      var _values$demandDraft3, _renderExpandedCards$15, _renderExpandedCards$16, _renderExpandedCards$17, _renderExpandedCards$18, _values$demandDraft4;

      setExpandCard(values === null || values === void 0 ? void 0 : (_values$demandDraft3 = values.demandDraft) === null || _values$demandDraft3 === void 0 ? void 0 : _values$demandDraft3.length);
      renderExpandedCards.current = [].concat(_toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$15 = renderExpandedCards.current) === null || _renderExpandedCards$15 === void 0 ? void 0 : (_renderExpandedCards$16 = _renderExpandedCards$15.filter(function (card) {
        var _card$cardName16, _card$cardName16$toSt, _card$cardName16$toSt2;

        return card === null || card === void 0 ? void 0 : (_card$cardName16 = card.cardName) === null || _card$cardName16 === void 0 ? void 0 : (_card$cardName16$toSt = _card$cardName16.toString()) === null || _card$cardName16$toSt === void 0 ? void 0 : (_card$cardName16$toSt2 = _card$cardName16$toSt.toLowerCase()) === null || _card$cardName16$toSt2 === void 0 ? void 0 : _card$cardName16$toSt2.startsWith('dd');
      })) === null || _renderExpandedCards$16 === void 0 ? void 0 : _renderExpandedCards$16.map(function (card) {
        return _objectSpread2(_objectSpread2({}, card), {}, {
          flag: false
        });
      })), _toConsumableArray(renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$17 = renderExpandedCards.current) === null || _renderExpandedCards$17 === void 0 ? void 0 : _renderExpandedCards$17.filter(function (card) {
        var _card$cardName17, _card$cardName17$toSt, _card$cardName17$toSt2;

        return !(card !== null && card !== void 0 && (_card$cardName17 = card.cardName) !== null && _card$cardName17 !== void 0 && (_card$cardName17$toSt = _card$cardName17.toString()) !== null && _card$cardName17$toSt !== void 0 && (_card$cardName17$toSt2 = _card$cardName17$toSt.toLowerCase()) !== null && _card$cardName17$toSt2 !== void 0 && _card$cardName17$toSt2.startsWith('dd'));
      })));
      renderExpandedCards === null || renderExpandedCards === void 0 ? void 0 : (_renderExpandedCards$18 = renderExpandedCards.current) === null || _renderExpandedCards$18 === void 0 ? void 0 : _renderExpandedCards$18.push({
        cardName: "dd ".concat((values === null || values === void 0 ? void 0 : (_values$demandDraft4 = values.demandDraft) === null || _values$demandDraft4 === void 0 ? void 0 : _values$demandDraft4.length) + 1),
        flag: true
      });
      setFieldValue("demandDraft", [].concat(_toConsumableArray(values.demandDraft), [{
        ifscCode: '',
        bankName: '',
        ddNumber: '',
        ddDate: data === null || data === void 0 ? void 0 : data.maxDate,
        paymentAmount: '',
        branchName: '',
        branchLocation: ''
      }]));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-sm"
  }, "Add DD")))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SearchResultsModal, {
    modalSizeExternal: modalSizeExternal,
    modalDisplay: ifscModalDisplay,
    searchInput: searchInput,
    searchResults: searchResults,
    paginationInput: paginationInput,
    title: 'Search IFSC Code',
    onClose: onClose,
    onDataUpdate: onDataUpdate,
    onNoResultsFound: onNoResultsFound,
    onMessage: onMessage,
    selectOnRowClick: true,
    firstRowClickRequired: false
  })));
}

export { GET_DOCUMENTS_INFO as $, AGENCY_NAME as A, BUY_POLICY as B, CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL$1 as C, DemandDraft as D, DEFAULT_BANK_NAME as E, FINAL_COLLECTION_DATE as F, GET_CUSTOMER_TYPE_DOMAIN$1 as G, HOUSE_BANK_BRANCH_FETCH as H, ISSUE_POLICY as I, PROPOSER_DROPDOWN_DETAIL as J, KASH_PASH_SLIP as K, LOOKUP_INTERMEDIARY as L, GET_DATE_TIME as M, GET_GENDER_LIST as N, OnlinePayment as O, PAY_PREMIUM_LIST$1 as P, QUERY_STATE as Q, RENEWAL_MANDATE_DETAILS as R, SEARCH_CUSTOMERS as S, PAY_PREMIUM_LIST as T, VERIFY_ONLINE_TRANSACTION as U, VERIFY_ONLINE_TRANSACTION$1 as V, INTERMEDIARY_CD_ACCOUNTS as W, ROLLOVER_COMPANY_LIST as X, CHARACTER_LIMIT_LIST as Y, RELATIONSHIP_WITH_PROPOSER as Z, DOCUMENT_STATIC_DATA as _, GET_DATE_TIME$1 as a, GET_DOCUMENTS_LIST as a0, VIEW_DOCUMENT as a1, UPLOAD_DOCUMENT as a2, INSERT_DOCUMENT_LIST as a3, PROFILE_DETAILS as a4, Cheque as b, CAR_VEHICLE_INSPECTION as c, INTERMEDIARY_CD_ACCOUNTS$1 as d, CUSTOMER_BANK_DETAILS$1 as e, HOUSE_BANK_ACCOUNT_FETCH as f, GET_INTERMEDIARY_LIST as g, GET_BUY_HEALTH_POLICY_VAR_DETAILS as h, CUSTOMER_INDIVIDUAL_DROPDOWN_DETAIL as i, PINCODE_LOOKUP as j, CUSTOMER_ORGANISATIONAL_DROPDOWN_DETAIL as k, DEFAULT_ID_PROOF as l, GET_CUSTOMER_TYPE_DOMAIN as m, GET_BUSINESS_TYPE as n, CHECK_IMD_CONFIG as o, SAVE_QUOTE as p, SEARCH_CUSTOMER_BY_NUMBER as q, GET_MEDICAL_QUESTIONS as r, LOB_PRODUCT_LIST as s, SEND_POLICY_SMS as t, SEND_POLICY_EMAIL as u, SEND_POLICY_PDF as v, CALCULATE_PREMIUM_FOR_PROPOSAL as w, SAVE_PROPOSAL as x, SEND_PROPOSAL_PDF as y, CUSTOMER_BANK_DETAILS as z };
